import type { LoyaltyTransaction } from '~/api/user/loyalty/types';
import { entities } from '~/enitityHelper';

const prefixes: Record<LoyaltyTransaction['type'], string> = {
  cancel: '',
  accrual: 'Начисление за ',
  debit: 'Списание за ',
  expiration: 'Сгорание бонусов',
  hold: 'Удержание бонусов за ',
  release: 'Разблокировка бонусов за ',
};

const capitalizeFirstLetter = (val: string): string => {
  return String(val).charAt(0).toUpperCase() + String(val).slice(1);
};

export const getLoyaltyTransactionDescription = (transaction: LoyaltyTransaction) => {
  const prefix = prefixes[transaction.type];

  if (transaction.type === 'expiration') return prefix;

  const entity = entities[transaction?.project?.entity as keyof typeof entities]?.name;
  const title = `«${transaction?.project?.title}»`;

  return capitalizeFirstLetter(`${prefix}${entity} ${title}`);
};
